import { Navigate } from '@tanstack/react-router';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { useAnalyticsProfileContext } from '../analytics-profile-context';
import { AnalyticsInstagramInteraction } from './analytics-instagram-interaction';

export const AnalyticsInteraction = () => {
  const { selectedSocialAccount } = useAnalyticsProfileContext();

  switch (selectedSocialAccount.socialMedia) {
    case AnalyticsSupportedSocialMediaType.instagram:
      return <AnalyticsInstagramInteraction />;
    default:
      return <Navigate to="/analytics" />;
  }
};
